import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { UserCardPage } from '../features/users/card-page'

export const userCardRoute = createRoute({
  path: 'users/$userId',
  getParentRoute: () => rootRoute,
  component: function UserCardRoute() {
    const { userId } = userCardRoute.useParams()
    return <UserCardPage userId={userId} />
  },
})
